import { useCallback, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { scrollToId } from "./scroll";

export const useGoToSection = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  return useCallback(
    (id) => {
      if (pathname === "/") scrollToId(id);
      else navigate("/", { state: { scrollTo: id } });
    },
    [pathname, navigate]
  );
};

export const useScrollFromState = () => {
  const location = useLocation();
  useEffect(() => {
    const id = location.state?.scrollTo;
    if (!id) return;
    const t = setTimeout(() => scrollToId(id), 150);
    return () => clearTimeout(t);
  }, [location]);
};
